import apiURLBuilder from '../core/apiURLBuilder';
import Api from '../services/api';
import actionTypes from 'constants/actionTypes';
import { actions as formActions } from 'react-redux-form';
import { FUNDS, PLANS, PORTFOLIO } from 'constants/products';
import { goToErrorsView } from './errorViewNavigation';

const getProductActivated = partnerProduct => {
    return dispatch => {
        dispatch(formActions.change('userProfile.productType', partnerProduct.get('type')));
        dispatch(formActions.change('userProfile.productSubtype', partnerProduct.get('subtype')));
        dispatch(formActions.change('userProfile.productStandard', partnerProduct.get('standard')));
    };
};

const getProductsService = (dispatch, callback) => {
    const getProductsURL = apiURLBuilder.getURL('getProducts');
    Api.get(getProductsURL).then(response => {
        if (response.body.status === 'Error') {
            callback(false, response);
            dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getProductsURL }));
        } else {
            const data = response.body || [];

            dispatch(formActions.change('userProfile.product', data.productCode));

            dispatch({
                type: actionTypes.LOAD_PRODUCTS,
                data,
            });

            callback(true);
        }
    });
};

const getProducts = callback => {
    return dispatch => {
        getProductsService(dispatch, callback);
    };
};

const setProductsInfo = data => {
    return dispatch => {
        dispatch({
            type: actionTypes.LOAD_PRODUCTS,
            data,
        });
    };
};

const clearProductsInfo = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_PRODUCTS,
        });
    };
};

const getCreditCardOffer =
    (checked, codeId, language = 'es') =>
    dispatch => {
        const saveRequestData = {
            header: {},
            query: {
                isOpenCredit: checked,
                language,
            },
        };

        if (codeId && ![FUNDS, PLANS, PORTFOLIO].includes(codeId.toLowerCase())) {
            saveRequestData.query.promotionalCode = codeId;
        }

        // Check promotionalCode action when updating this endpoint
        const getPromotionalCodesURL = apiURLBuilder.getURL('getPromotionalCodes');

        return Api.get(getPromotionalCodesURL, saveRequestData).then(response => {
            if (response.body.status !== 'Error') {
                const data = response.body || [];

                dispatch({
                    type: actionTypes.UPDATE_PRODUCTS,
                    data,
                });
            } else {
                dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getPromotionalCodesURL }));
            }
        });
    };

const getOrDeleteCreditCard = (checked, accessToken) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {
            openCredit: checked,
        },
    };

    const getOrDeleteCreditCardURL = apiURLBuilder.getURL('getOrDeleteCreditCard');

    return Api.post(getOrDeleteCreditCardURL, saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            const data = response.body || [];

            dispatch({
                type: actionTypes.LOAD_PRODUCTS,
                data,
            });
        } else {
            dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getOrDeleteCreditCardURL }));
        }
    });
};

const getCreditCardProduct = partnerId => dispatch => {
    const getCreditCardProductURL = apiURLBuilder.getURL('creditCardProduct', { partnerId });
    const handleSuccessResponse = response =>
        dispatch({ type: actionTypes.LOAD_PARTNER, data: { id: partnerId, ...response.body } });
    const handleErrorResponse = error =>
        dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: getCreditCardProductURL }));

    return Api.get(getCreditCardProductURL).then(handleSuccessResponse, handleErrorResponse);
};

export default {
    getOrDeleteCreditCard,
    getCreditCardOffer,
    getProducts,
    setProductsInfo,
    clearProductsInfo,
    getProductActivated,
    getCreditCardProduct,
};
